import jsPDF from 'jspdf';
import { Device } from '../interfaces';

export const getSelectedDevices = (selectedRows: string[], devices: Device[]) => {
    return selectedRows
        .map((id) => devices.find((device) => device.deviceId === id))
        .filter((device): device is Device => Boolean(device));
};

export const exportToFile = (devices: Device[]) => {
    const formattedData = devices.map((device) => `${device.deviceId}`);
    const blob = new Blob([formattedData.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'Devices.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const transformToPdfTable = (devices: Device[], numColumns: number) => {
    const numRows = Math.ceil(devices.length / numColumns);
    const table: Array<Array<Device | null>> = [];

    for (let i = 0; i < numRows; i++) {
        const row: Array<Device | null> = devices.slice(i * numColumns, (i + 1) * numColumns);

        while (row.length < numColumns) {
            row.push(null);
        }

        table.push(row);
    }

    return table;
};

export const exportToPdf = (devices: Device[]) => {
    const doc = new jsPDF();
    const columns = 6;
    const rowsPerPage = 15;
    const tableData = transformToPdfTable(devices, columns);
    const cellWidth = 31.7;
    const cellHeight = 17.5;
    let y = 23;
    let rowCount = 0;

    doc.setFontSize(11.8);
    doc.setDrawColor(200, 200, 200);

    tableData.forEach((row) => {
        if (rowCount >= rowsPerPage) {
            doc.addPage();
            doc.setFontSize(11.8);
            y = 23;
            rowCount = 0;
        }

        let x = 10;
        row.forEach((device) => {
            doc.rect(x, y - 8, cellWidth, cellHeight);

            if (device) {
                const text = `${device.deviceId}`;
                const textWidth = doc.getTextWidth(text);
                doc.text(text, x + cellWidth - textWidth - 3, y + 5.5);
            }

            x += cellWidth;
        });

        y += cellHeight;
        rowCount++;
    });

    doc.save('Devices.pdf');
};
